import React, { useEffect, useState } from 'react';
import DisplayNameIcon from 'components/base/display-name-icon';
import { ReactComponent as MenuIcon } from 'assets/icons/three_dots.svg';
import { ReactComponent as RestoreIcon } from 'assets/icons/like.svg';
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg';
import RiderDetailsSideModal from '../partners/partner-modals/rider-details-modal';
import RestoreDeleteRiderModal, { ModalType } from './restore-delete-rider-modal';
import {
  Dropdown,
  DropdownItem,
  DropdownList,
  Table,
  TableData,
  TableRow,
  checkIfAllSelected,
  updateAllSelections,
  updateSelection
} from '@cokitchen/cokitchen-components';
import { RecentlyDeletedType } from 'models/bin.model';
import { RiderType } from 'models/rider.model';
import { formatNumber, getUserName } from 'utils/functions';
const TABLE_HEADERS = ['Rider name', 'Trips Completed', 'Amount earned', 'Partner', 'Actions', ''];
const RecentlyDeletedList = ({ list }: { list: RecentlyDeletedType[] }) => {
  const [showRestoreDeleteModal, setShowRestoreDeleteModal] = useState(false);
  const [modalType, setModalType] = useState<ModalType>('Restore');
  const restoreRider = () => {
    setModalType('Restore');
    setShowRestoreDeleteModal(true);
  };

  const deleteRider = () => {
    setModalType('Delete');
    setShowRestoreDeleteModal(true);
  };

  const MENU_LIST = [
    {
      icon: <RestoreIcon />,
      text: 'Restore rider',
      onClick: restoreRider
    },
    {
      icon: <DeleteIcon />,
      text: 'Remove rider',
      onClick: deleteRider
    }
  ];
  const [selected, setSelected] = useState<string[]>([]);
  const [isAllSelected, setAllSelected] = useState(false);
  const [activeRider, setActiveRider] = useState<RiderType | null>(null);
  const [showRiderDetails, setShowRiderDetails] = useState(false);
  const [bulkRiders, setBulkRiders] = useState([] as RiderType[] | null);

  const viewDetails = () => {
    setShowRiderDetails(!showRiderDetails);
  };

  const getBulkRiders = (selected: string[]) => {
    const data = list.map(({ rider }) => rider);
    let riders;
    if (selected.length > 1) {
      riders = data.filter(({ id }) => selected.includes(id));
      setBulkRiders(riders);
    } else {
      riders = activeRider ? [activeRider] : null;
      setBulkRiders(riders);
    }
  };

  const updateSelections = () => {
    const data = list.map(({ rider }) => rider);
    setSelected(updateAllSelections(data, selected, isAllSelected));
  };

  const updateSingleSelection = (item: RiderType) => {
    setSelected(updateSelection(selected, item.id));
  };

  useEffect(() => {
    const data = list.map(({ rider }) => rider);
    setAllSelected(checkIfAllSelected(data, selected));
  }, [selected]);

  useEffect(() => {
    getBulkRiders(selected);
  }, [selected, activeRider]);

  return (
    <div>
      <Table
        headers={TABLE_HEADERS}
        canSelect
        isAllSelected={isAllSelected}
        onToggleAll={updateSelections}>
        {list?.map((item) => {
          return (
            <TableRow
              key={item.rider.id}
              canSelect
              isSelected={selected.includes(item.rider.id)}
              onToggle={() => updateSingleSelection(item.rider)}>
              <TableData className='py-6'>
                <p className='flex items-center gap-2'>
                  <DisplayNameIcon active={item.rider?.online} user={item.rider} />
                  <span>{getUserName(item.rider)}</span>
                </p>
              </TableData>
              <TableData>
                <span>{item.trips_completed || 0} trips</span>
              </TableData>
              <TableData>{formatNumber(item.earned)}</TableData>
              <TableData>
                <span>{item.rider?.logistics_company_id}</span>
              </TableData>
              <TableData>
                <span
                  className='underline cursor-pointer text-sm font-medium text-red-5 '
                  onClick={() => setShowRiderDetails(true)}>
                  View details
                </span>
              </TableData>
              <TableData className='text-gray-4'>
                <Dropdown
                  className='min-w-[180px]'
                  content={<MenuIcon onClick={() => setActiveRider(item.rider)} />}>
                  <DropdownList>
                    {MENU_LIST.map(({ text, icon, onClick }, i) => (
                      <DropdownItem
                        className={`${MENU_LIST.length - 1 === i ? 'text-red-5' : 'text-gray-6'}`}
                        buttonClassName='flex items-center gap-4'
                        key={i}
                        onClick={onClick}>
                        {icon} {text}
                      </DropdownItem>
                    ))}
                  </DropdownList>
                </Dropdown>
              </TableData>
            </TableRow>
          );
        })}
      </Table>

      <RiderDetailsSideModal
        rider={activeRider ?? ({} as RiderType)}
        show={showRiderDetails}
        onClose={viewDetails}
      />
      <RestoreDeleteRiderModal
        show={showRestoreDeleteModal}
        onClose={() => setShowRestoreDeleteModal(false)}
        type={modalType}
        riders={bulkRiders ?? ({} as RiderType[])}
      />
    </div>
  );
};

export default RecentlyDeletedList;
